import CancelButton from 'Components/Generic/Buttons/CancelButton';
import DeleteButton from 'Components/Generic/Buttons/DeleteButton';
import { useAlertContext } from 'Data/context/Alerts';
import { user_roles } from 'Data/Enum';
import ResourceData from 'Data/ResourceData';
import SiteDrawerData from 'Data/SiteDrawerData';
import DataManager from 'Lib/DataManager';
import ServiceContractInformationPanel from 'Pages/ServiceContracts/ServiceContractInformationPanel';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { isUserAuthorized } from 'Util';
import ResourceInformationPanel from './ResourceInformationPanel';

let DM = new DataManager();

const ResourceView = ({
  resourceId,
  params,
  editable = false,
  onDeleteResource = () => {},
  ...props
}) => {
  const { openDeleteDialog, showDeletedToast } = useAlertContext();
  const [resource, setResource] = useState({});

  useEffect(() => {
    DM.add(
      ResourceData.registerListener('BLANK_RECORD_LOADED', onResourceLoaded),
      ResourceData,
    );
    DM.add(
      ResourceData.registerListener('RECORD_LOADED', onResourceLoaded),
      ResourceData,
    );
    DM.add(
      ResourceData.registerListener('RECORDS_DELETED', onResourceDeleted),
      ResourceData,
    );

    return () => {
      DM.clear();
    };
  }, []);

  useEffect(() => {
    if (!resourceId && !params?.id) {
      ResourceData.getBlank();
    }
  }, []);

  useEffect(() => {
    if (resourceId && resourceId > 0) {
      getResource(resourceId);
    }
  }, [resourceId]);

  useEffect(() => {
    if (params?.id && !resourceId) {
      getResource(params.id);
    }
  }, [params]);

  const refreshResource = useCallback(() => {
    resource?.id && getResource(resource.id);
  }, [resource]);
  const getResource = (id) => {
    ResourceData.getResourceAndAssociations(id);
  };

  const onResourceLoaded = (payload) => {
    if (payload) {
      setResource(payload);
    }
  };

  const deleteClicked = () => {
    if (resource.id) {
      openDeleteDialog({
        objectType: `Resource`,
        onConfirmDelete: () => ResourceData.deleteRecords(resource.id),
      });
    } else {
      onDeleteResource();
    }
  };

  const onResourceDeleted = () => {
    onDeleteResource();
    SiteDrawerData.close();
    showDeletedToast(`Resource`);
  };

  let cancelDeleteButton =
    editable &&
    isUserAuthorized({
      roles: [user_roles.ADMINISTRATOR],
    }) &&
    (resource?.id ? (
      <DeleteButton
        onDeleteItem={deleteClicked}
        tooltipText={'Delete Resource'}
      />
    ) : (
      <CancelButton onCancel={SiteDrawerData.close} />
    ));

  return (
    resource && (
      <div
        style={{
          display: 'flex',
          gap: 10,
          flexDirection: 'column',
          maxWidth: 800,
        }}>
        <ResourceInformationPanel
          resourceObject={resource}
          editable={editable}
          collapsible={false}
          onResourceSaved={refreshResource}
          {...props}
        />
        {resource?.service_contract_details?.length
          ? resource.service_contract_details.map((scd, index) => (
              <ServiceContractInformationPanel
                key={index}
                serviceContractObject={
                  scd.service_contracts?.length && scd.service_contracts[0]
                }
                linkToServiceContractPage
              />
            ))
          : undefined}
        {cancelDeleteButton}
      </div>
    )
  );
};

ResourceView.propTypes = {
  resourceId: PropTypes.number,
  params: PropTypes.shape({ id: PropTypes.string }),
  editable: PropTypes.bool,
  onDeleteResource: PropTypes.func,
};

export default ResourceView;
